import React, { useState } from 'react'
import './Card.css'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from "../../i18n/custom.i18n";
import { LazyLoadImageCDN } from "./CDNImage";

import { OverlayContainer } from './CardStylings';
import { getUrlCompliantName } from './cardUtils';

export function RobotCard(p: any) {

    const { t, i18n } = useTranslation();

    const [OverlayDisplay, setOverlayDisplay] = useState("none");
    const overlayHeightRef = React.useRef("auto");

    // TODO: Move to .init( ? this won't change
    //var robodk_web_open = window.Paths.ROBODK_WEB_OPEN_CDN ? window.Paths.ROBODK_WEB_OPEN_CDN + "/downloads-library/library-robots/" : window.Paths.ROBODK_WEB_OPEN + "/robotlib/lib/";
    var lang_add = "";
    if (window.Languages.language != "en"){
        lang_add = window.Languages.language + "/";
    }
    var robodk_web_open = window.Paths.ROBODK_WEB_3D + lang_add + "robot/" + p.file;
    if (robodk_web_open.endsWith(".robot")){
        robodk_web_open = robodk_web_open.slice(0, -6);
    }

    var showDetails = true;

    var BrandURL = getUrlCompliantName(p.brand);  // Han's
    var ModelURL = getUrlCompliantName(p.model); // .. (AT_000)
    let NameURL = p.file.split(".", 1)[0];

    let DetailsURL = window.Paths.HOST_DETAILS;
    if (window.Settings.LOCAL_BUILD) {
        switch (window.Languages.language) {
            case "en":
                DetailsURL += window.Paths.DETAILS_URL + "robot=" + NameURL;
                break;

            default:
                DetailsURL += window.Paths.DETAILS_URL + "Lang=" + window.Languages.language + "&" + "robot=" + NameURL;
                break;
        }
    } else {
        switch (window.Languages.language) {
            case "en":
                // DetailsURL = "/robot-test/" + BrandURL + "/" + ModelURL;
                DetailsURL += "/robot/" + BrandURL + "/" + ModelURL;
                break;

            default:
                // DetailsURL = "/robot-test/" + window.Languages.language + "/" + BrandURL + "/" + ModelURL;
                DetailsURL += "/robot/" + window.Languages.language + "/" + BrandURL + "/" + ModelURL;
                break;
        }
    }

    return (
        <div id={NameURL} className="library-robot-container">
            <div
                className="library-robot"
                onMouseEnter={(e: React.MouseEvent) => {
                    if (OverlayDisplay === "none") {
                        let robot_title = e.currentTarget.childNodes[0] as HTMLHeadingElement;
                        let robot_image = e.currentTarget.childNodes[1] as HTMLDivElement;
                        let image_padding = 17;

                        overlayHeightRef.current = (robot_title.clientHeight + robot_image.clientHeight + image_padding).toString();

                        setOverlayDisplay("flex");
                    }
                }}

                onMouseLeave={(e: React.MouseEvent) => setOverlayDisplay("none")}
            >
                <h6 className="robot-title">{p.name}</h6>
                <div className="image-box">
                    <LazyLoadImageCDN 
                        cdnPath={window.FOLDER_TYPE_IMG_MAP_CDN[p.category] + p.img}
                        localPath={window.FOLDER_TYPE_IMG_MAP[p.category] + p.img}
                        alt={p.name}
                        libAssetsPath={window.Paths.ROBOT_LIB_ASSETS}
                        classname={"img-robot"}
                    />
                </div>
                {showDetails &&
                    <table className="table table-striped">
                        <tbody>
                            {p.brand &&
                                <tr>
                                    <td>{t('filters-robots.brand')}</td>
                                    <td>{p.brand}</td>
                                </tr>
                            }
                            {p.model &&
                                <tr>
                                    <td>{t('filters-robots.model')}</td>
                                    <td>{p.model}</td>
                                </tr>
                            }
                            {(p.type && !(p.type.includes("DOF"))) &&
                                <tr>
                                    <td>{t('filters-robots.type')}</td>
                                    <td>{p.type}</td>
                                </tr>
                            }
                            {p.axes > 0 &&
                                <tr>
                                    <td>{t('filters-robots.axes')}</td>
                                    <td>{p.axes}</td>
                                </tr>
                            }
                            {p.reach > 0 &&
                                <tr>
                                    <td>{t('filters-robots.reach')}</td>
                                    <td>{p.reach} mm</td>
                                </tr>
                            }
                            {p.payload > 0 &&
                                <tr>
                                    <td>{t('filters-robots.payload')}</td>
                                    <td>{p.payload > 2 ? p.payload.toFixed() : +p.payload.toFixed(1)} kg</td>
                                </tr>
                            }
                            {p.weight > 0 &&
                                <tr>
                                    <td>{t('filters-robots.weight')}</td>
                                    <td>{p.weight > 2 ? p.weight.toFixed() : +p.weight.toFixed(1)} kg</td>
                                </tr>
                            }
                            {p.repeatability > 0 &&
                                <tr>
                                    <td>{t('filters-robots.repeatability')}</td>
                                    <td>{p.repeatability.toFixed(3)} mm</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }

            </div>
            <OverlayContainer
                key={"overlay-" + p.name}
                height={overlayHeightRef.current}
                display={OverlayDisplay}
            >
                <div className="robot-links">
                    {window.Settings.open_in_rdk &&
                        <div
                            onClick={(e) => window.get_lib(true, p.file, "robot")}
                            role="button"
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardOpenBtn')}</strong>
                        </div>
                    }
                    {
                        <a
                            href={DetailsURL}
                            //onClick={(e) => window.open(DetailsURL, "_blank")}
                            target="_blank"
                            type="button"
                            role="button"
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardDetailsBtn')}</strong>
                        </a>
                    }
                    {!window.Settings.on_robodk_web &&
                        <a
                            href={robodk_web_open}
                            target="_blank"
                            type="button"
                            role="button"
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardView3DBtn')}</strong>
                        </a>
                    }
                    {
                        <div
                            onClick={(e) => window.get_lib(false, p.file, "robot")}
                            role="button"
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardDownloadBtn')}</strong>
                        </div>
                    }
                </div>
            </OverlayContainer>
        </div>
    )
}
